import React, { useState, useRef, useCallback } from 'react';
import { Flex, Box, Input, IconButton, Button } from '@chakra-ui/react';
import { BsMic, BsSend } from 'react-icons/bs';

export const ChatInput = ({ onSend, disabled }) => {
  const [value, setValue] = useState('');
  const debounceRef = useRef(null);

  const debouncedSend = useCallback(() => {
    if (debounceRef.current || !value.trim()) return;
    onSend(value.trim());
    setValue('');
    debounceRef.current = setTimeout(() => {
      debounceRef.current = null;
    }, 1000);
  }, [onSend, value]);

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !disabled) {
      debouncedSend();
    }
  };

  return (
    <Flex pt={2} borderTopWidth="1px" alignItems="center" gap={2}>
      <Box flex={1} position="relative">
        <Input
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Ask a question about your events, campaigns, or cohorts…"
          h={10}
          pr={12}
          fontSize="sm"
          disabled={disabled}
        />
        <IconButton
          aria-label="Voice input"
          variant="ghost"
          size="sm"
          position="absolute"
          right={2}
          top="50%"
          transform="translateY(-50%)"
          h={7}
          px={2}
        >
          <BsMic color="gray" />
        </IconButton>
      </Box>
      <Button
        onClick={debouncedSend}
        h={10}
        px={5}
        bg="var(--brand-primary)"
        color="white"
        _hover={{ bg: 'var(--brand-primary-hover)' }}
        disabled={disabled || !value.trim()}
      >
        <BsSend />
      </Button>
    </Flex>
  );
};
